// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const Accordion = registerClientReference(
    function() { throw new Error("Attempted to call Accordion() from the server but Accordion is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/ui/accordion.tsx",
    "Accordion",
);
export const AccordionContent = registerClientReference(
    function() { throw new Error("Attempted to call AccordionContent() from the server but AccordionContent is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/ui/accordion.tsx",
    "AccordionContent",
);
export const AccordionItem = registerClientReference(
    function() { throw new Error("Attempted to call AccordionItem() from the server but AccordionItem is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/ui/accordion.tsx",
    "AccordionItem",
);
export const AccordionTrigger = registerClientReference(
    function() { throw new Error("Attempted to call AccordionTrigger() from the server but AccordionTrigger is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/ui/accordion.tsx",
    "AccordionTrigger",
);
